import { ReactNode } from 'react';
import { Box, Grid } from '@mui/material';

export const CountdownContainer = ({ children }: { children: ReactNode }) => (
    <Box
        component={Grid}
        item
        xs={12}
        sx={({ palette }) => ({
            px: '12px',
            py: '4px',
            borderTop: '1px solid',
            borderTopColor: palette.neutralLightGrey.main
        })}
    >
        {children}
    </Box>
);
